var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyStar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5383 0.859965C13.7091 0.449318 14.2909 0.449318 14.4617 0.859964L17.8503 9.00715C17.9223 9.18027 18.0851 9.29856 18.272 9.31354L27.0675 10.0187C27.5109 10.0542 27.6906 10.6075 27.3529 10.8968L20.6516 16.6372C20.5092 16.7592 20.447 16.9506 20.4905 17.1329L22.5378 25.7159C22.641 26.1485 22.1704 26.4905 21.7909 26.2586L14.2606 21.6592C14.1006 21.5615 13.8994 21.5615 13.7394 21.6592L6.20913 26.2586C5.82958 26.4905 5.35896 26.1485 5.46215 25.7159L7.50951 17.1329C7.55301 16.9506 7.49083 16.7592 7.34843 16.6372L0.64713 10.8968C0.309362 10.6075 0.489124 10.0542 0.932451 10.0187L9.72803 9.31354C9.91492 9.29856 10.0777 9.18027 10.1497 9.00715L13.5383 0.859965Z",
    fill: "#E6E6E6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty_star.a44da2d1.svg";
export { ForwardRef as ReactComponent };